// extracted by mini-css-extract-plugin
export default {"wrap":"NotFound_wrap__7uKR4","code":"NotFound_code__q-PuN","title":"NotFound_title__Ua+sk","sub":"NotFound_sub__lqMy6","btn":"NotFound_btn__65M+U"};